import { render, staticRenderFns } from "./categoryManage.vue?vue&type=template&id=473cd742&"
import script from "./categoryManage.vue?vue&type=script&lang=js&"
export * from "./categoryManage.vue?vue&type=script&lang=js&"
import style0 from "./categoryManage.vue?vue&type=style&index=0&id=473cd742&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports